import { Component, Input } from '@angular/core';
import { ClientChore } from 'app/core/models/client-chore.model';
import { ClientChoreInitiatedVia } from 'app/core/enums/client-chore-initiated-via.enum';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-client-chore-lifecycle',
    templateUrl: './client-chore-lifecycle.component.html',
    styleUrls: ['./client-chore-lifecycle.component.scss'],
    imports: [DatePipe]
})
export class ClientChoreLifecycleComponent {
  @Input() clientChore: ClientChore;

  clientChoreInitiatedVia = ClientChoreInitiatedVia;
}
